import { render } from "./quaryboard.vue?vue&type=template&id=01a8872b&scoped=true"
import script from "./quaryboard.vue?vue&type=script&lang=js"
export * from "./quaryboard.vue?vue&type=script&lang=js"

import "./quaryboard.vue?vue&type=style&index=0&id=01a8872b&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a8872b"]])

export default __exports__